import type { SVGProps } from 'react';

const SvgPoint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <defs>
      <mask id='hole-mask'>
        <rect fill='white' height='24' width='24' x='0' y='0' />
        <path
          d='M9.614 11.695c-.06 0-.1.014-.119.042-.02.021-.03.06-.03.116V13.4c0 .099-.023.169-.069.21-.04.043-.106.064-.198.064H8c-.086 0-.152-.021-.198-.063a.328.328 0 0 1-.06-.21V6.578c0-.098.02-.168.06-.21.046-.042.112-.063.198-.063h2.327c2.04 0 3.06.887 3.06 2.663 0 .898-.268 1.579-.803 2.042-.534.456-1.31.684-2.327.684h-.643Zm0-3.705c-.06 0-.1.014-.119.042-.02.021-.03.06-.03.116v1.705c0 .056.01.098.03.126.02.021.06.032.119.032h.643c.443 0 .776-.084 1-.253.232-.175.347-.435.347-.779 0-.344-.112-.593-.337-.747-.217-.161-.554-.242-1.01-.242h-.643Z'
          fill='black'
        />
      </mask>
    </defs>

    <path
      d='M9.99 17.98A7.99 7.99 0 1 0 9.99 2a7.99 7.99 0 0 0 0 15.98Z'
      fill='currentColor'
      mask='url(#hole-mask)'
    />
    <path
      d='M21.97 15.99c0 3.3-2.68 5.98-5.98 5.98a5.97 5.97 0 0 1-4.91-2.57 9.458 9.458 0 0 0 8.32-8.32 5.97 5.97 0 0 1 2.57 4.91Z'
      fill='currentColor'
      opacity={0.4}
    />
  </svg>
);
export default SvgPoint;
